import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RequestedDocuments } from 'src/app/admin/case-management/requested-documents';
import { Application, Spouse } from 'src/app/applications/application/application';
import { ConfigServices } from 'src/app/core/config';
import { Attachment } from 'src/app/core/models';

@Component({
  selector: 'app-case-documents',
  templateUrl: './case-documents.component.html',
  styleUrls: ['./case-documents.component.scss']
})
export class CaseDocumentsComponent implements OnInit {
  @Input() application!: Application;
  @Input() submittedDocuments!: RequestedDocuments;
  uploadedDocuments: Attachment[] = [];
  uploadedDocumentsHeading: string[] = [];
  selectedIndex: number = -1;

  constructor(private configServices: ConfigServices, private http: HttpClient, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.application.disabilityAnnexure) {
      this.uploadedDocumentsHeading.push(`Disability Annexture: [${this.application.disabilityAnnexure.name}]`)
      this.uploadedDocuments.push(this.application.disabilityAnnexure);
      this.getURL(this.application.disabilityAnnexure);
    }

    if (this.application.vulnerableChildOrNonSassDeclaration) {
      this.uploadedDocumentsHeading.push(`Vulnerable Child: [${this.application.vulnerableChildOrNonSassDeclaration.name}]`);
      this.uploadedDocuments.push(this.application.vulnerableChildOrNonSassDeclaration);
      this.getURL(this.application.vulnerableChildOrNonSassDeclaration);
    }

    this.populateSupportingDocuments("Mother", this.application.mother);
    this.populateSupportingDocuments("Father", this.application.father);
    this.populateSupportingDocuments("Guardian", this.application.guardian);
    this.populateSupportingDocuments("Spouse", this.application.spouse);
    
    if (this.submittedDocuments.disabilityAnnexure) {
      this.uploadedDocumentsHeading.push(`Disability Annexture: [${this.submittedDocuments.disabilityAnnexure.name}]`);
      this.uploadedDocuments.push(this.submittedDocuments.disabilityAnnexure);
      this.getURL(this.submittedDocuments.disabilityAnnexure);
    }

    if (this.submittedDocuments.vulnerableChildOrNonSassDeclaration) {
      this.uploadedDocumentsHeading.push(`Vulnerable Child: [${this.submittedDocuments.vulnerableChildOrNonSassDeclaration.name}]`);
      this.uploadedDocuments.push(this.submittedDocuments.vulnerableChildOrNonSassDeclaration);
      this.getURL(this.submittedDocuments.vulnerableChildOrNonSassDeclaration);
    }

    this.populateSubmittedDocuments("Mother", this.submittedDocuments.mother);
    this.populateSubmittedDocuments("Father", this.submittedDocuments.father);
    this.populateSubmittedDocuments("Guardian", this.submittedDocuments.guardian);
    this.populateSubmittedDocuments("Spouse", this.submittedDocuments.spouse);
    this.populateSubmittedDocuments("Applicant", this.submittedDocuments.student);
    this.populateSubmittedDocuments("Applicant", this.submittedDocuments.appeals);
  }

  private populateSubmittedDocuments(heading: string, attachments: Attachment[] | null | undefined) {
    if (attachments === null || attachments === undefined) {
      return;
    }
    attachments.forEach(document => {
      if (document.id) {
        this.uploadedDocumentsHeading.push(`${heading}'s ${document.documentType}: [${document.name}]`);
        this.getURL(document);
        this.uploadedDocuments.push(document)
      }
    })
  }

  private populateSupportingDocuments(heading: string, careGiver: Spouse): void {
    if (careGiver === null || careGiver === undefined || careGiver.supportingDocs === null || careGiver.supportingDocs === undefined) {
      return;
    }
    
    if (careGiver?.supportingDocs) {
      careGiver.supportingDocs.forEach(document => {
        if (document.id) {
          this.uploadedDocumentsHeading.push(`${heading}'s ${document.documentType}: [${document.name}]`);
          this.getURL(document);
          this.uploadedDocuments.push(document)
        }
      })
    }
  }

  getURL(attachment: Attachment) {
    const url = this.configServices.getApi() + 'file/' + attachment.id;
    this.http.get(url,{observe: 'response', responseType: 'blob'}).subscribe((res) => {
      const objectURL = URL.createObjectURL(res.body);
      const image = this.sanitizer.bypassSecurityTrustResourceUrl(objectURL);
      attachment.url = image;
    });
  }

  onImageChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.selectedIndex = +target.value;
  }
}
